import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HubConnection } from '@aspnet/signalr';
// import { HubConnection } from '@microsoft/signalr';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { ResponseContext } from 'src/app/core/net/response-context.interface';
import { SettingsService } from 'src/app/core/services/settings.service';
import { generateTaskId } from '../../utils';
import { ChatService } from '../chat.service';
import { decodeDom2, decodeText, EMOJI_URL } from '../emoji-picker/emojiMap';

import { IChatRecordResponse, MessagePack, MessageStatusNotice, RtcEventArgs } from '../model';
import { RtcService } from '../rtc.service';

@Component({
  selector: 'app-live-room',
  templateUrl: './live-room.component.html',
  styleUrls: ['./live-room.component.less']
})
export class LiveRoomComponent implements OnInit {
  @ViewChild('camera', { static: false }) camera: ElementRef;
  @ViewChild('screen', { static: false }) screen: ElementRef;
  @ViewChild('messageTextElement', { static: false }) messageTextElement?: ElementRef;
  
  private connection: HubConnection;
  canTo: boolean = true;
  timer: string;
  tabIndex = 1;
  loadingChatRecord = false;
  messageText: string = "";
  inputMaxLength = 1000;
   //输入框防抖动
   private inputSubject = new Subject<any>();
   //输入框输入订阅
   private inputSubscription: Subscription;
  //聊天记录
  chatRecordData: Array<MessagePack> = [];
  //分页信息
  pageInfo = { pageIndex:1, pageSize: 15, dataCount: 0, totalPage: 0 };
  //最后一次滚动条位置
  lastscrollHeight = 0;
  showEmojiPicker: boolean = false;
 
  constructor(private message: NzMessageService, public settings: SettingsService, public chat: ChatService, public rtcService: RtcService, private cd: ChangeDetectorRef) {

  
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.stopTimer();
    this.inputSubscription.unsubscribe();
  }
  ngAfterViewInit(){
  this.camera.nativeElement.addEventListener('loadedmetadata', function() {
    console.log(`Remote video videoWidth: ${this.videoWidth}px,  videoHeight: ${this.videoHeight}px`);
  });

 }
  ngOnInit() {
    this.registerSignalR();
    this.rtcService.changeEvent.subscribe((n: RtcEventArgs) => {
      switch (n.type) {
        case 'renderLocalStream':
          this.renderLocalStream(n)
          break;
        case 'renderRemoveStream':
          this.renderRemoveStream(n);
          break;
      }
    });
    this.startTimer();
 
    //输入框延时订阅
    this.inputSubscription = this.inputSubject.pipe(
      debounceTime(50)
    ).subscribe(e => {
      if (e.type == 'input') {
        this.messageText = decodeDom2(this.messageTextElement.nativeElement.innerHTML);
        console.log(this.messageText);
      }

    });
  }

  async registerSignalR() {
    this.connection = await this.chat.connection;
    this.loadQueryChatRecord();
    this.connection.on("broadcastLiveMessageStatus", (c: ResponseContext<MessageStatusNotice>) => {
      if (c.Status != 200) {
        this.message.error("消息发送失败");
        return;
      }
      var m = this.chatRecordData.find(n => n.PackageId == c.Result.PackageId);
      if (m) {
        m.SendStatus = 1;
        m.SendTime = c.Result.SendTime;
        m.Id = c.Result.MessageRecordId;
      }
    });
    this.connection.on("liveChatRecord", (n: ResponseContext<IChatRecordResponse>) => {
      this.lastscrollHeight = document.getElementById("chatContext").scrollHeight;
      var c = n.Result.data;
      this.pageInfo.dataCount = n.Result.pager.dataCount;
      var page = (this.pageInfo.dataCount + this.pageInfo.pageSize - 1) / this.pageInfo.pageSize;
      this.pageInfo.totalPage = parseInt(page.toString());
      c.forEach(n => {
        this.chatRecordData.unshift(n);
      });
      this.loadingChatRecord = false;
      this.cd.detectChanges();
      var location = document.getElementById("chatContext").scrollHeight - this.lastscrollHeight;
      document.getElementById("chatContext").scrollTop = (location);//+50
    });

    this.connection.on("broadcastLiveMessage", (n: MessagePack) => {
      var sessionId = n.ObjectType == 0 ? n.SendUserId : n.ReceiveId;
      if (n.SendUserId == this.settings.user.userId) {
        return;
      }
      this.connection.send("UpdateToRead",'36ACC490-9D10-4DAC-8282-450A2F080276');
      this.chatRecordData.push(n);
    
    });

  }
  loadQueryChatRecord() {
    var query = {
      pagerInfo: this.pageInfo,
      queryJson: {
        UserId: this.settings.user.userId,
        ObjectId:this.settings.liveInfo.GroupId??'36ACC490-9D10-4DAC-8282-450A2F080276', //this.settings.liveInfo.GroupId,
        ObjectType: 2
      },
      sortInfo: null
    };
    this.connection.send("QueryLiveChatRecord", query);

  }
  

  ngAfterViewChecked() {
    if (this.settings.messageBox.selectIndex == 1 && this.pageInfo.pageIndex == 1 && this.canTo) {
      this.scrollToBottom();
    }

  }
  renderLocalStream(e: RtcEventArgs) {
    if (e.streamType == 0) {
      if (!this.screen) {
        return;
      }
      this.screen.nativeElement.srcObject = e.stream;
    } else {
      if (!this.camera) {
        return;
      }
      this.camera.nativeElement.srcObject = e.stream;
    }
  }
  renderRemoveStream(e: RtcEventArgs) {
    if (e.streamType == 0) {
      if (!this.screen) {
        return;
      }
      if (this.screen.nativeElement.srcObject !== e.stream.streams[0]) {
        this.screen.nativeElement.srcObject = e.stream.streams[0];
      }
    } else {
      if (!this.camera) {
        console.log('this camera is not read!')
        return;
      }
      if (this.camera.nativeElement.srcObject !== e.stream.streams[0]) {
        this.camera.nativeElement.srcObject = e.stream.streams[0];
      }
   
      console.log(this.camera.nativeElement.srcObject)
    }

  }

  close() {
    this.stopTimer();
    this.rtcService.leaveRoom(true);
  }


  _time: NodeJS.Timer;
  startTimer() {
    this._time = setInterval((a) => {
      if (!this.settings.liveInfo.StartDate) {
        return;
      }
      var startTime = new Date(this.settings.liveInfo.StartDate);
      var d = new Date();

      this.timer = this.diffTime(startTime, d);

    }, 1000);
  }
  stopTimer() {
    clearInterval(this._time);
  }

  diffTime(startDate, endDate) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    var diff = endDate.getTime() - startDate.getTime();//时间差的毫秒数 

    //计算出相差天数 
    var days = Math.floor(diff / (24 * 3600 * 1000));

    //计算出小时数 
    var leave1 = diff % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数 
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数 
    var leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数 
    var minutes = Math.floor(leave2 / (60 * 1000));

    //计算相差秒数 
    var leave3 = leave2 % (60 * 1000);      //计算分钟数后剩余的毫秒数 
    var seconds = Math.round(leave3 / 1000);

    var returnStr = "";
    if (hours >= 10) {
      returnStr += hours + ":";
    } else {
      returnStr += "0" + hours + ":";
    }

    if (minutes >= 10) {
      returnStr += minutes + ":";
    } else {
      returnStr += "0" + minutes + ":";
    }

    if (seconds >= 10) {
      returnStr += seconds;
    } else {
      returnStr += "0" + seconds;
    }
    return returnStr;
  }

  screenClick() {
    if (!this.settings.liveInfo.IsCreator) {
      return;
    }
    this.rtcService.toggleScreen();
  }
  cameraClick() {
    if (!this.settings.liveInfo.IsCreator) {
      return;
    }
    this.rtcService.toggleCamera();
  }
  audioClick() {
    if (!this.settings.liveInfo.IsCreator) {
      return;
    }
    this.rtcService.toggleAudio();
  }


  tab(index) {
    this.tabIndex = index;
  }
 
  morePage() {
    if (this.pageInfo.totalPage > this.pageInfo.pageIndex) {
      this.loadingChatRecord = true;
      setTimeout(() => {
        this.pageInfo.pageIndex += 1;
        this.loadQueryChatRecord();
      }, 500);
    }
  }
  onscroll(e) {
    var top = e.target.scrollTop;
    if (top == 0 && this.pageInfo.totalPage > this.pageInfo.pageIndex && this.chatRecordData.length > 0) {

      this.morePage();
    }
  }
  onmousewheel(e) {
    this.canTo = false;
    var dom = document.getElementById("chatContext");
    if (e.wheelDelta < 0 && dom.scrollHeight > dom.clientHeight && (dom.scrollTop + dom.clientHeight) === dom.scrollHeight) {
      this.canTo = true;
    }

  }
 
  textareaInput(e: KeyboardEvent) {
    if (e.key == "Backspace") {
      if (this.messageTextElement.nativeElement.lastChild?.nodeName != "BR") {
        var br = document.createElement('br');

        this.messageTextElement.nativeElement.append(br);
      }
    }
    this.inputSubject.next({ type: 'input' });
  }

  onTextKeyDown(e: KeyboardEvent) {
    if (e.ctrlKey && e.key == 'KeyA') {

      return true;
    }
    setTimeout(() => {
      if (this.messageTextElement.nativeElement.innerText.length > this.inputMaxLength) {
        this.messageTextElement?.nativeElement.focus();
        document.execCommand("Delete", false, null);
        e.returnValue = false;
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.message.create('info', '最大限制字数' + this.inputMaxLength);
        return false;
      }
    }, 10);
    if (e.key == "Enter") {
      this.send();
      return false;
    }

  }
  scrollToBottom(force?: boolean) {
    this.cd.detectChanges();
    var dom = document.getElementById("chatContext");
    if (!dom) {
      return;
    }
    if (((dom.scrollTop + dom.clientHeight) != dom.scrollHeight && this.canTo) || force) {
      dom.scrollTo({ left: 0, top: dom.scrollHeight })

    }
  }
  emojiClick(e: { key: string, value: string }) {
    this.showEmojiPicker = false;
    var node = document.createElement("img");
    node.setAttribute('img-key', e.key);
    node.src = EMOJI_URL + e.value;
    document.execCommand('inserthtml', true, node.outerHTML);
    this.inputSubject.next({ type: 'input' });
  }

  send() {
    if (!this.messageText.trimStart()) {
      return;
    }
    var packList = decodeText(this.messageText);
    packList.forEach(n => {
      var context = n.value;
      var cmp: MessagePack = {
        PackageId: generateTaskId(),
        Type: n.type,
        MessageText: context,
        ReceiveId: this.settings.liveInfo.GroupId??'36ACC490-9D10-4DAC-8282-450A2F080276',
        SendUserId: this.settings.user.userId,
        SendName: this.settings.user.name,
        SendStatus: 0,
        SendUserHeadImg: this.settings.user.avatar,
        ObjectType: 2,
        IsMe: true,
        MediaUrl: null
      };
      this.chatRecordData.push(cmp);
      this.scrollToBottom(true);
      this.connection.send("SendLiveGroupMessage", cmp);

      this.messageText = "";
      this.messageTextElement?.nativeElement.focus();
      this.messageTextElement.nativeElement.innerHTML = "";
    });
  }

  banMessageClick(){
    this.rtcService.toggleSendMessage();
  }
}
